




















import Vue from "vue";
import router from "@/router";
import userInfoProvider from "../services/userInfoProvider";
import defaultDataProviderFactory from "@/services/identity-authen/defaultDataProvider";
import configProvider from "@/services/configProvider"

const defaultDataProvider = defaultDataProviderFactory();

export default Vue.extend({
  name: "Header",
  data() {
    return {
      logoUrl: configProvider.get("LOGO_URL") || "",
      userInfo: {},
    };
  },
  methods: {
    async logout() {
      try {
        await defaultDataProvider.execute("Logout", {
          body: {}
        });
        userInfoProvider.deleteAccessToken();
        localStorage.clear()
        this.logoutDialog = false;
        router.push("/login/prepare");
      } catch (e) {

      }
    },
    goToDownloadPage() {
      const routeData = this.$router.resolve({
        name: 'download',
      });
      window.open(routeData.href, '_blank');
    }
  },
  created() {
    this.userInfo = userInfoProvider.getUserInfo();
  }
});
